import { Grid } from '@mui/material';
import { useField } from 'react-final-form';

import { InfoField } from '@occc/ui-design-system';
import { CampaignSelect } from '@occc-app/routes/CampaignComponents/components/CampaignSelect';

import { CampaignFormValue } from '../../types';

type OfferCampaignFieldProps = {
  canEdit: boolean;
};

const OfferCampaignReadOnlyField = () => {
  const { input } = useField<CampaignFormValue | undefined>('campaign', {
    subscription: { value: true },
  });

  return <InfoField label='Campaign' value={input.value?.name} />;
};

export const OfferCampaignField = ({ canEdit }: OfferCampaignFieldProps) => {
  return (
    <Grid item xs={4}>
      {canEdit ? <CampaignSelect label='Campaign' /> : <OfferCampaignReadOnlyField />}
    </Grid>
  );
};
